import React from 'react';
import styled from 'styled-components';
import Footer from './Footer';

// Shared chrome for the setup screens (entry/gender/personality): the centered
// card layout, the DreamDate logo and tagline, and the footer. Keeping it in one
// place lets each step be its own route/page without repeating the wrapper.
const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: #f8f9fa;
`;

const Logo = styled.h1`
  color: #e91e63;
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
  text-align: center;
`;

const Tagline = styled.p`
  color: #666;
  margin-bottom: 2rem;
  text-align: center;
  font-size: 1.2rem;
`;

const Layout = ({ children }) => (
  <Container>
    <Logo>DreamDate</Logo>
    <Tagline>Practice your conversation skills with AI personalities<br />and receive feedback from a virtual coach.</Tagline>
    {children}
    <Footer />
  </Container>
);

export default Layout;
